import React, { FC, useState, useCallback, useEffect } from "react";

import {
  StyledInputSubmenu,
  StyledInputSubmenuFooter,
  StyledInput,
} from "./Styles";
import { Button } from "../Button";

interface InputSubmenuProps {
  value?: string;
  placeholder?: string;
  saveLabel: string;
  clearLabel?: string;
  onSave: (value: string) => void;
  onClear: () => void;
}

export const InputSubmenu: FC<InputSubmenuProps> = ({
  value = "",
  placeholder,
  saveLabel,
  clearLabel = "Clear",
  onSave,
  onClear,
}) => {
  const [inputValue, setInputValue] = useState(value);

  useEffect(() => {
    setInputValue(value);
  }, [value]);

  const handleChange = useCallback(
    (event: React.ChangeEvent<HTMLInputElement>) => {
      setInputValue(event.target.value);
    },
    []
  );

  const handleSave = useCallback(() => {
    onSave(inputValue);
  }, [inputValue, onSave]);

  const handleKeyDown = useCallback(
    (event: React.KeyboardEvent<HTMLInputElement>) => {
      if (event.key === "Enter") {
        onSave(inputValue);
      }
    },
    [inputValue, onSave]
  );

  return (
    <StyledInputSubmenu>
      <StyledInput
        value={inputValue}
        onChange={handleChange}
        onKeyDown={handleKeyDown}
        placeholder={placeholder}
      />
      <StyledInputSubmenuFooter>
        <Button variant="primary" size="small" onClick={handleSave}>
          {saveLabel}
        </Button>
        <Button variant="text gray" size="small" onClick={onClear}>
          {clearLabel}
        </Button>
      </StyledInputSubmenuFooter>
    </StyledInputSubmenu>
  );
};
